import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import axios from '../../axios';
import classes from './Devices.module.css';
import { parseDateToEpoch } from '../../utils/parseDateToEpoch';

const Devices = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const columns = [
    { 
      name: 'Serial number', 
      selector: row => row.serialNumber || '', 
      sortable: true, 
      style: { fontSize: '15px' }
    },
    { 
      name: 'Device EUI', 
      selector: row => row.deviceEUI || '', 
      sortable: true, 
      style: { fontSize: '14px' }
    },
    { 
      name: 'Device model', 
      selector: row => row.deviceModel || '', 
      sortable: true, 
      style: { fontSize: '14px' }
    },
    { 
      name: 'Project', 
      selector: row => row.projectName || '', 
      sortable: true, 
      style: { fontSize: '14px' }
    },
    { 
      id: 'dateAdded',
      name: 'Date added', 
      selector: row => parseDateToEpoch(row.dateAdded),
      cell: row => row.dateAdded || '',
      sortable: true, 
      style: { fontSize: '14px' }
    },
  ];

  useEffect(() => {
    loadDevices();
  }, []);

  const loadDevices = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/devices/organization');
      if (response.data && response.data.devices) {
        setDevices(response.data.devices);
      } else if (Array.isArray(response.data)) {
        setDevices(response.data);
      } else {
        setDevices([]);
      }
    } catch (error) {
      console.error('Failed to load devices:', error);
      setDevices([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClaimDevice = () => {
    navigate('/devices/claim-device');
  };

  return (
    <div className={classes.devices}>
      <div className={classes.header}>
        <h2 className={classes.title}>Devices</h2>
        <button onClick={handleClaimDevice} className={classes.claimButton}>
          Claim device
        </button>
      </div>

      <DataTable
        columns={columns}
        data={devices}
        progressPending={loading}
        noHeader={true}
        pagination={true}
        highlightOnHover={true}
        striped={true}
        defaultSortFieldId="dateAdded"
        defaultSortAsc={false}
        noDataComponent="No devices found"
        onRowClicked={(row) => navigate(`/devices/${row.id}`)}
        pointerOnHover={true}
        customStyles={{
          headCells: { 
            style: { 
              fontWeight: 'bold', 
              fontSize: '15px' 
            }
          }
        }}
      />
    </div>
  );
};

export default Devices;

